import type { DTOActiveSubscription } from 'src/apis/dto/DTOSubscription';

export const getSubscriptionByProductType = (
  subscriptions: DTOActiveSubscription[] | undefined,
  productType: string
): DTOActiveSubscription | undefined => {
  return subscriptions?.find((s) => s.productType === productType);
};

/**
 * 특정 productType을 제외한 구독을 찾습니다.
 * upgrade/downgrade 시 현재 구독(타겟과 다른 productType)을 찾는 데 사용됩니다.
 */
export const getSubscriptionExcludingProductType = (
  subscriptions: DTOActiveSubscription[] | undefined,
  excludeProductType: string
): DTOActiveSubscription | undefined => {
  return subscriptions?.find((s) => s.productType !== excludeProductType);
};
